import React from "react";
import { useLang } from "../contexts/LanguageContext";
import CountUp from "./CountUp";

const Export = () => {
  const { t } = useLang();
  const stats = t.exportSec.stats;

  const regions = [
    "European Union",
    "Middle East",
    "North Africa",
    "Central Asia",
    "South-East Asia",
    "United Kingdom",
  ];

  return (
    <section
      id="export"
      data-testid="export-section"
      className="relative bg-[#1A201C] text-[#FDFBF7] py-24 md:py-32 overflow-hidden"
    >
      {/* Subtle dotted pattern */}
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "radial-gradient(circle, #DE9E36 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
        aria-hidden="true"
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 mb-20">
          <div className="lg:col-span-7 reveal">
            <div className="flex items-center gap-3 mb-6">
              <span className="divider-line" />
              <span className="overline text-[#DE9E36]">{t.exportSec.overline}</span>
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl text-white font-bold leading-[1.1] tracking-tight">
              {t.exportSec.title}
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pt-3 reveal">
            <p className="text-base text-white/75 leading-relaxed">{t.exportSec.p}</p>
          </div>
        </div>

        {/* Stats grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border-y border-white/10">
          {stats.map((s, i) => (
            <div
              key={i}
              data-testid={`export-stat-${i}`}
              className="reveal bg-[#1A201C] py-10 px-6 text-center"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="text-5xl md:text-6xl text-[#DE9E36] font-bold tracking-tight">
                <CountUp value={s.v} />
              </div>
              <div className="mt-3 overline text-white/60">{s.l}</div>
            </div>
          ))}
        </div>

        {/* Regions list */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-6 gap-y-4 text-center">
          {regions.map((r, i) => (
            <div
              key={i}
              className="reveal py-3 border-b border-white/15 text-sm text-white/80 hover:text-[#DE9E36] transition-colors"
            >
              {r}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Export;
